// DS: MO5.2
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import AdoptableButton from '@wix/da-ds/pkg/Buttons/AdoptableButton';
import { ListItemDiv } from '@wix/da-ds/pkg/List/ListItem';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import AdoptableCountdown from '@wix/da-ds/pkg/Time/AdoptableCountdown';
import { useRestrictToLoggedInAndVerified } from '../../../../../../utils/hooks/useRestrictToLoggedInAndVerified';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import { formatDollars as originalFormatDollars, OPTIONAL_DECIMAL_DIGITS } from '../../../../../../utils/formatting';
import useAdoptableState from './useAdoptableState';
import s from './AdoptOnSide.scss';
const OFFERS_DISPLAY_MAX = 3;
// Avoid showing decimal digits unless necessary
const formatDollars = (amount)=>originalFormatDollars(amount, OPTIONAL_DECIMAL_DIGITS);
const AdoptOnSide = ({ className, deviation, buyerViewOffersModal, buyerOfferModal, sellerViewOffersModal, sellerEditSaleModal })=>{
    var _offer_from;
    const { t } = useTranslation();
    const { isSeller, canBuyNow, canMakeNewOffer, canManageExistingOffer, canBuyerViewOffers, canSellerViewOffers, canSeeMinOfferPrice, hasOffers, offersList, minOfferPrice, fixedPrice, offerEndTime, offerTimerHasEnded, onTimerEnd } = useAdoptableState(deviation);
    // Restrict buy actions to logged in and verified users
    const buyFixedPrice = useCallback(()=>{
        var _deviation_extended_adoptable_fixedPrice, _deviation_extended_adoptable, _deviation_extended;
        var _deviation_extended_adoptable_fixedPrice_subproductId;
        window.location.assign(Url.checkoutLink((_deviation_extended_adoptable_fixedPrice_subproductId = (_deviation_extended_adoptable_fixedPrice = (_deviation_extended_adoptable = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.fixedPrice) === null || _deviation_extended_adoptable_fixedPrice === void 0 ? void 0 : _deviation_extended_adoptable_fixedPrice.subproductId) !== null && _deviation_extended_adoptable_fixedPrice_subproductId !== void 0 ? _deviation_extended_adoptable_fixedPrice_subproductId : 0));
    }, [
        deviation
    ]);
    const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();
    const restrictedBuyNow = restrictToLoggedInAndVerified(ReferralType.ACTION_BAR, undefined, buyFixedPrice);
    const restrictedBuyerOfferModal = restrictToLoggedInAndVerified(ReferralType.ACTION_BAR, undefined, buyerOfferModal);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, isSeller ? t('sidebar.adoptableInfo.title.seller') : t('sidebar.adoptableInfo.title.buyer')), /*#__PURE__*/ React.createElement("div", {
        className: s['message']
    }, isSeller ? t('sidebar.adoptableInfo.subheading.seller') : t('sidebar.adoptableInfo.subheading.buyer')), canBuyNow && /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['big-button'],
        priority: canMakeNewOffer || canManageExistingOffer || canBuyerViewOffers ? 'secondary' : 'primary',
        biData: BiData({
            evid: 750,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            purchase_price: fixedPrice,
            sectionname: 'side_rail'
        }),
        onClick: restrictedBuyNow
    }, t('sidebar.adoptableInfo.adopt.cta.buyItNow', {
        price: formatDollars(fixedPrice)
    })), canMakeNewOffer && /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['big-button'],
        priority: "primary",
        biData: BiData({
            evid: 751,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'side_rail'
        }),
        onClick: restrictedBuyerOfferModal
    }, t('sidebar.adoptableInfo.adopt.cta.makeOffer')), canManageExistingOffer && /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['big-button'],
        priority: "primary",
        biData: BiData({
            evid: 753,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'side_rail'
        }),
        onClick: restrictedBuyerOfferModal
    }, t('sidebar.adoptableInfo.adopt.cta.manageOffer')), canBuyerViewOffers && /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['big-button'],
        priority: "primary",
        biData: BiData({
            evid: 746,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'side_rail'
        }),
        onClick: buyerViewOffersModal
    }, t('sidebar.adoptableInfo.adopt.cta.viewOffers')), isSeller && /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['big-button'],
        priority: "secondary",
        biData: BiData({
            evid: 742,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'side_rail'
        }),
        onClick: sellerEditSaleModal
    }, t('sidebar.adoptableInfo.adopt.cta.editSale')), canSellerViewOffers && /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['big-button'],
        priority: hasOffers ? 'primary' : 'secondary',
        biData: BiData({
            evid: 746,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'side_rail'
        }),
        onClick: sellerViewOffersModal
    }, t('sidebar.adoptableInfo.adopt.cta.viewOffers')), /*#__PURE__*/ React.createElement("div", {
        className: s['key-numbers']
    }, canSeeMinOfferPrice && /*#__PURE__*/ React.createElement("div", {
        className: s['key-number']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, t('sidebar.adoptableInfo.adopt.details.minOffer')), /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, formatDollars(minOfferPrice))), offerEndTime && /*#__PURE__*/ React.createElement("div", {
        className: s['key-number']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, t(offerTimerHasEnded ? 'sidebar.adoptableInfo.adopt.details.offerEnded' : 'sidebar.adoptableInfo.adopt.details.offerEnd')), /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, /*#__PURE__*/ React.createElement(AdoptableCountdown, {
        offerEndTime: offerEndTime,
        endedClassName: s['offer-ended'],
        endedMessage: `00:00:00`,
        onEnd: onTimerEnd
    })))), hasOffers && /*#__PURE__*/ React.createElement("div", {
        className: s['offers']
    }, offersList.slice(0, OFFERS_DISPLAY_MAX).map((offer, index)=>/*#__PURE__*/ React.createElement(ListItemDiv, {
            key: index,
            className: s['offer'],
            noHorizontalPaddings: true,
            prefix: /*#__PURE__*/ React.createElement(UserAvatar, {
                user: offer.from,
                size: 24
            }),
            label: (_offer_from = offer.from) === null || _offer_from === void 0 ? void 0 : _offer_from.username,
            suffix: /*#__PURE__*/ React.createElement("span", {
                className: s['offer-price']
            }, formatDollars(offer.dollarPrice))
        }))), offersList.length > OFFERS_DISPLAY_MAX && /*#__PURE__*/ React.createElement(TextButton, {
        className: s['show-all-offers'],
        size: "medium",
        variant: "main",
        onClick: isSeller ? sellerViewOffersModal : canMakeNewOffer || canManageExistingOffer ? restrictedBuyerOfferModal : buyerViewOffersModal
    }, t('sidebar.adoptableInfo.adopt.cta.showAllOffers', {
        offersCount: offersList.length
    })));
};
AdoptOnSide.displayName = 'AdoptOnSide';
export default AdoptOnSide;
